import { mergeDeepRight, reduce } from 'ramda'

/**
 * Merges all objects in a list recursively.
 * Values in later positions in the list are prioritized.
 */
export const mergeDeepAll = (objs: object[]) =>
  reduce<object, object>(mergeDeepRight, {}, objs)
